import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationModule } from '@galaxy/crm/static';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'crm-page-not-found',
  template: `
    <glxy-page [pagePadding]="false">
      <glxy-empty-state class="empty-state-container">
        <glxy-empty-state-hero>
          <mat-icon>sentiment_dissatisfied</mat-icon>
        </glxy-empty-state-hero>
        <glxy-empty-state-title>{{ 'PAGE_NOT_FOUND.HEADER' | translate }}</glxy-empty-state-title>
        <p>{{ 'PAGE_NOT_FOUND.HINT' | translate }}</p>
      </glxy-empty-state>
    </glxy-page>
  `,
  styleUrls: ['./page-not-found.component.scss'],
  providers: [],
  imports: [CommonModule, TranslateModule, TranslationModule, GalaxyPageModule, GalaxyEmptyStateModule, MatIconModule],
})
export class CrmPageNotFoundComponent {
  constructor(private router: Router) {
    const url = decodeURIComponent(this.router.url);

    if (url !== this.router.url) {
      this.router.navigateByUrl(url);
    }
  }
}
